/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as axios from 'axios';
import type {
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  CreatePayoutDto,
  ListPayablesParams,
  PayPayoutNowDto,
  PayPayoutsNowDto,
  PayoutDetailDto,
  PayoutListItemDtoPaginatedResult,
  PayoutStatsDto,
  VoidPayoutDto
} from '.././types';




  /**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const listPayables = <TData = AxiosResponse<PayoutListItemDtoPaginatedResult>>(
    params?: ListPayablesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/payouts/payables`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const getPayableStats = <TData = AxiosResponse<PayoutStatsDto>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/payouts/payables/stats`,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_GET
 */
export const getPayableById = <TData = AxiosResponse<PayoutDetailDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/payouts/payables/${id}`,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_GET
 */
export const getPayableByPayoutRequestId = <TData = AxiosResponse<PayoutDetailDto>>(
    payoutRequestId: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/payouts/payables/by-payout-request/${payoutRequestId}`,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_PAY_NOW
 */
export const payPayoutNow = <TData = AxiosResponse<PayoutDetailDto>>(
    id: string,
    payPayoutNowDto: PayPayoutNowDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/payouts/payables/${id}/pay-now`,
      payPayoutNowDto,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_PAY_NOW
 */
export const payPayoutsNow = <TData = AxiosResponse<void>>(
    payPayoutsNowDto: PayPayoutsNowDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/payouts/payables/pay-now`,
      payPayoutsNowDto,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_CREATE
 */
export const createPayout = <TData = AxiosResponse<PayoutDetailDto>>(
    createPayoutDto: CreatePayoutDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/payouts`,
      createPayoutDto,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_UPDATE
 */
export const retryPayout = <TData = AxiosResponse<PayoutDetailDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/payouts/${id}/retry`,undefined,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_VOID
 */
export const voidPayout = <TData = AxiosResponse<PayoutDetailDto>>(
    id: string,
    voidPayoutDto: VoidPayoutDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/payouts/${id}/void`,
      voidPayoutDto,options
    );
  }
export type ListPayablesResult = AxiosResponse<PayoutListItemDtoPaginatedResult>
export type GetPayableStatsResult = AxiosResponse<PayoutStatsDto>
export type GetPayableByIdResult = AxiosResponse<PayoutDetailDto>
export type GetPayableByPayoutRequestIdResult = AxiosResponse<PayoutDetailDto>
export type PayPayoutNowResult = AxiosResponse<PayoutDetailDto>
export type PayPayoutsNowResult = AxiosResponse<void>
export type CreatePayoutResult = AxiosResponse<PayoutDetailDto>
export type RetryPayoutResult = AxiosResponse<PayoutDetailDto>
export type VoidPayoutResult = AxiosResponse<PayoutDetailDto>
